module.exports = __webpack_public_path__ + "img/ranking-2.4a3f27cd.svg";